import { apiGet, apiPost } from "@/core/api";
import { Session } from "@/core/session";
import { Citizen, Core } from "@minicity/core";
import { CitizenInvite, ClassifierQuestionType } from "./model";

export const validateCitizenInviteToken = async (inviteCode: string) => 
    apiGet<CitizenInvite>(`/citizenOnboarding/invite/${inviteCode}`);

export const isUsernameAvailable = async (inviteCode: string, username: string) => 
    apiGet<boolean>(`/citizenOnboarding/invite/${inviteCode}/usernameAvailability/${username}`);

export interface RegisterRequest {
    inviteCode: string;
    siteId: string;
    caseWorkerId: string;
    assignedAmbassador?: string;
    hmisId?: string;
    housingReadinessLocation?: string;
    housingReadinessType?: string;

    verificationSelfie?: Core.Document;

    username: string;
    password: string;

    agreedTermsVersion: number;
    equifaxConsent: boolean;

    profile: Citizen.Profile;
    classifierQuestionAnswers: any; // Maps from question ID to answer ID
    demographics: string[];
    needs: string[];

    signature: string;  // Base64-encoded 'data:image/png;base64,...' image    
    idempotencyToken: string;
}

export interface RegisterResponse {
    sessionId: string;
}

export const register = (req: RegisterRequest) => {
    return apiPost<RegisterResponse>("/citizenOnboarding/citizen", req);
}